import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';

export const AddOwnershipDialog = ({ open, onOpenChange, investors, ownershipForm, setOwnershipForm, totalOwnership, onSubmit, formLoading }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">Add Ownership</DialogTitle>
          <DialogDescription>Assign an investor to this LLC</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Partner</Label>
              <Select value={ownershipForm.investor_id} onValueChange={(value) => setOwnershipForm({ ...ownershipForm, investor_id: value })}>
                <SelectTrigger><SelectValue placeholder="Select partner" /></SelectTrigger>
                <SelectContent>
                  {investors.map((inv) => (
                    <SelectItem key={inv.id} value={inv.id}>{inv.name} ({inv.email})</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Ownership Percentage</Label>
              <Input
                type="number"
                step="0.00001"
                min="0"
                max={100 - totalOwnership}
                value={ownershipForm.percentage}
                onChange={(e) => setOwnershipForm({ ...ownershipForm, percentage: e.target.value })}
                placeholder={`Max: ${(100 - totalOwnership).toFixed(5)}%`}
                required
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" className="bg-slate-900 hover:bg-slate-800" disabled={formLoading}>
              {formLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Add Ownership'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddOwnershipDialog;
